module.exports = __webpack_public_path__ + "img/about-banner.75e1c591.png";